import { PromoCodeStats } from "../../../api/payments/promoCodes/promoCode.responses";
import { Button } from "../../ui/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/Dialog";

interface PromoCodeStatsDialogProps {
  open: boolean;
  onClose: () => void;
  stats: PromoCodeStats | null;
  statsLoading: boolean;
}

function PromoCodeStatsDialog({
  open,
  onClose,
  stats,
  statsLoading,
}: PromoCodeStatsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Promo Code Stats</DialogTitle>
        </DialogHeader>
        {statsLoading ? (
          <p className="text-sm text-muted-foreground">Loading stats…</p>
        ) : stats ? (
          <div className="space-y-4">
            <p className="font-mono text-lg font-bold">{stats.code}</p>
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-md border p-3">
                <p className="text-sm text-muted-foreground">Total Applied</p>
                <p className="text-2xl font-bold">{stats.totalApplications}</p>
              </div>
              <div className="rounded-md border p-3">
                <p className="text-sm text-muted-foreground">Completed</p>
                <p className="text-2xl font-bold">
                  {stats.completedApplications}
                </p>
              </div>
              <div className="rounded-md border p-3">
                <p className="text-sm text-muted-foreground">Pending</p>
                <p className="text-2xl font-bold">{stats.pendingApplications}</p>
              </div>
              <div className="rounded-md border p-3">
                <p className="text-sm text-muted-foreground">Conversion Rate</p>
                <p className="text-2xl font-bold">{stats.conversionRate}%</p>
              </div>
            </div>
          </div>
        ) : null}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default PromoCodeStatsDialog;
